import { BaseDataModel } from "@domain/BaseDataModel";

export class Region extends BaseDataModel {
	name!: string;
	branchIds?: string[];
	companyIds?: string[];
}
